import { ClickToEmail } from '../../../components/display/ClickToEmail';
import { resolveThemeColor } from '../../../constants/theme-aware-colors';
import { useTheme, useThemeColors } from '../../../providers/ThemeProvider';
import { useTranslation } from '../../../providers/TranslationProvider';
import type { FieldConfiguration, TableRow } from '../../types';
import { getFieldDisplayProperties } from './displayHelpers';

interface EmailDisplayProps {
	field: FieldConfiguration;
	value: any;
	data: TableRow;
}

export function EmailDisplay({ field, value, data }: EmailDisplayProps) {
	const colors = useThemeColors();
	const { isDark } = useTheme();
	const { t } = useTranslation();
	const { dataConfig } = field;

	// Get display value and color using value mapping
	const { displayValue, colorValue } = getFieldDisplayProperties(
		field,
		value,
		data,
	);
	const textColor =
		resolveThemeColor(colorValue?.text, isDark) ?? colors.values.textPrimary;

	if (value == null && dataConfig?.defaultValue == null) {
		return null;
	}

	// Check if the value is the default value
	const isDefaultValue = value === dataConfig?.defaultValue;

	// Use mapped display value if different from original, otherwise use original email
	const emailValue = String(displayValue).trim();

	// Don't render as link if it's the default value or if links are disabled
	if (field.link?.enabled !== false && !isDefaultValue && value != null) {
		return <ClickToEmail email={String(value)} />;
	}

	return <span style={{ color: textColor }}>{t(emailValue)}</span>;
}
